import { useCallback } from "react";
import { getTrainingSessionLogs } from "@/api";
import { resolveLoadErrorMessage } from "@/components/dataset";
import { isHttpClientError } from "@/http";
import { useCursorLogs, type CursorLogsErrorDecision, type CursorLogsState } from "@/lifecycle";

export { maxCursorLogLines as maxSessionLogLines } from "@/lifecycle";

export type TrainingSessionLogsState = CursorLogsState;

// 세션 상세 "로그" 탭은 endpoint 와 오류 정책만 소유한다. cursor polling 수명주기는 공용 hook 이 맡는다.
function resolveCursorLogsError(error: unknown): CursorLogsErrorDecision {
  return {
    message: resolveLoadErrorMessage(error),
    // attempt 가 없는 404 는 BE 가 빈 페이지로 처리한다. 여기 도달하는 404 는 결정적 실패다.
    terminal: isHttpClientError(error) && error.kind === "notFound",
  };
}

export function useTrainingSessionLogs(
  sessionId: string,
  sessionActive: boolean,
): TrainingSessionLogsState {
  const fetchPage = useCallback(
    (query: { since?: string; limit: number }) => getTrainingSessionLogs(sessionId, query),
    [sessionId],
  );
  return useCursorLogs(fetchPage, {
    targetActive: sessionActive,
    resolveError: resolveCursorLogsError,
  });
}
